import { render, staticRenderFns } from "./ServedAreas.vue?vue&type=template&id=c6ff9c66&"
import script from "./ServedAreas.vue?vue&type=script&lang=js&"
export * from "./ServedAreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports